import { render } from "./DashboardFleetLatestPayload.vue?vue&type=template&id=40315dfd"
import script from "./DashboardFleetLatestPayload.vue?vue&type=script&lang=js"
export * from "./DashboardFleetLatestPayload.vue?vue&type=script&lang=js"

import "./DashboardFleetLatestPayload.vue?vue&type=style&index=0&id=40315dfd&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__